import { render, staticRenderFns } from "./detail-log.vue?vue&type=template&id=f8358116&scoped=true&"
import script from "./detail-log.vue?vue&type=script&lang=js&"
export * from "./detail-log.vue?vue&type=script&lang=js&"
import style0 from "./detail-log.vue?vue&type=style&index=0&id=f8358116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8358116",
  null
  
)

export default component.exports